import styles from "./Notifier.module.scss";
import { useAppDispatch, useAppSelector } from "@redux/hooks";
import { FC, useEffect } from "react";
import { closeNotifier, selectNotifier } from "@redux/slices/CommonSlice";
import { error } from "console";

const Notifier: FC = () => {
  /* --------------------------------------------------------------------------
   * Redux State
   * -------------------------------------------------------------------------- */
  const { show, severity, message, title } = useAppSelector(selectNotifier);
  const dispatch = useAppDispatch();

  /* --------------------------------------------------------------------------
   * Auto-dismiss Effect
   * -------------------------------------------------------------------------- */
  /**
   * Automatically closes the notifier after 5 seconds
   * Cleans up timer on unmount or when show state changes
   */
  useEffect(() => {
    const timer = setTimeout(() => {
      if (show) dispatch(closeNotifier());
    }, 5000);

    return () => {
      clearTimeout(timer);
    };
  }, [show, dispatch]);

  /* --------------------------------------------------------------------------
   * Icon Configuration
   * -------------------------------------------------------------------------- */
  /** Icon displayed for success notifications */
  const successIcon = "/images/toast-success-tick.svg";
  /** Icon displayed for error notifications */
  const errorIcon = "/images/error-icon.svg";
  const infoIcon = "/images/block-restricted.svg";

  /* --------------------------------------------------------------------------
   * Render
   * -------------------------------------------------------------------------- */
  return (
    <>
      {show && (
        <div className={styles["notifier__wrapper"]}>
          {/* Icon Container */}
          <div className={styles["notifier__icon-container"]}>
            <img
              src={
                severity === "success"
                  ? successIcon
                  : severity === "info"
                    ? infoIcon
                    : errorIcon
              }
              alt={
                severity === "success"
                  ? successIcon
                  : severity === "info"
                    ? infoIcon
                    : errorIcon
              }
              height={24}
              width={24}
            />
          </div>

          {/* Content Container */}
          <div className={styles["notifier__content"]}>
            <p className={styles["notifier__title"]}>{title}</p>
            <p className={styles["notifier__message"]}>{message}</p>
          </div>
        </div>
      )}
    </>
  );
};

export default Notifier;
